export const options = {
  development: {
    realtimeServerApi: "http://localhost:8082",
    // realtimeServerApi: "https://realtime.to-day.app",
    realtimeServerPort: 8082,
    api: "http://localhost:8082",
    // api: "https://staging.to-day.app/api",
  },
  test: {
    realtimeServerApi: "https://realtime.to-day.app",
    realtimeServerPort: 8082,
    api: "https://staging.to-day.app/api",
  },
  production: {
    realtimeServerApi: "https://realtime.to-day.app",
    realtimeServerPort: 8082,
    api: "https://to-day.app/api",
  },
}[process.env.NODE_ENV];
